module.exports = __webpack_public_path__ + "img/bottom_step_icon_4.882320ea.png";